export default __webpack_public_path__ + "static/me-9355befd503297c9deecae73d146400a.jpg";